import Axios from 'axios';
import { loginService } from '../services/login.service';
import { userService } from '../services/user.service';

// export const API_HOST = "http://localhost:8080/api";
export const API_HOST = "https://webapp.idrivecompute.com/api";

// export const UI_HOST = "http://localhost:3000/app";
export const UI_HOST = "https://www.idrivecompute.com/app";

// export const UI_DOMAIN = "localhost";
export const UI_DOMAIN = "idrivecompute.com";

// export const API_DOMAIN = "localhost";
export const API_DOMAIN = "webapp.idrivecompute.com";

export const SLACK_CLIENT_ID = "3882701717094.3886380867573";
export const SLACK_BOT_SCOPES = "incoming-webhook,channels:read";
export const SLACK_USER_SCOPES = "identity.basic";
export const SLACK_REDIRECT_URI = encodeURI("https://webapp.idrivecompute.com/api/slack/oauth");
export const SLACK_APP_STATE = {
    "uuid": localStorage.getItem("userId"),
    "origin": UI_HOST
};
const SLACK_QUERY_PARAMS = {
    client_id: SLACK_CLIENT_ID,
    scope: SLACK_BOT_SCOPES,
    user_scope: SLACK_USER_SCOPES,
    redirect_uri: SLACK_REDIRECT_URI,
    state: encodeURI(Buffer.from(JSON.stringify(SLACK_APP_STATE)).toString('base64'))
};
export const SLACK_OAUTH_URL = "https://slack.com/oauth/v2/authorize?";

export const REVIEWER_EMAIL = "ritesh.tiwari+1@idrive.com";
export const REVIEWER_REGION = "LA3";

export const KB_ARTICLES_DOC = "https://docs.idrivecompute.com/hc/en-us/articles/";

export const REMEMBER_ME_TOKEN = "ICRM-ID";

export const EMAIL_TRANSFER_TOKEN = "ETX-TOKEN";

export const cookieConfig = {
    path: "/",
    domain: UI_DOMAIN,
    secure: true
};

export const axiosInstance = Axios.create({
    baseURL: API_HOST
});

const controller = new AbortController();

export const axiosRequest = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
    },
    signal: controller.signal
};
export var axiosRequestWithAuth = {
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Access-Control-Allow-Origin': '*',
    },
    signal: controller.signal
};

// Add interceptors
axiosInstance.interceptors.request.use(
    request => requestHandler(request)
);

axiosInstance.interceptors.response.use(
    response => responseHandler(response),
    error => errorHandler(error)
);

const requestHandler = (request) => {
    return request;
};

const responseHandler = (response) => {
    return response;
};

var tryRefresh = true;
var isRefreshing = false;
var errRefresh = false;

const errorHandler = async (error) => {
    let prevReq = error?.config;
    if(error?.response?.status === 401 && !prevReq.sent) {
        if(!isRefreshing) {
            if(tryRefresh) {
                // console.log("Access granted for " + prevReq?.url);
                tryRefresh = false;
                isRefreshing = true;
                prevReq.sent = true;
                await Axios.get(API_HOST + "/login/authenticate/refresh", axiosRequestWithAuth).then(resp => {
                    // console.log("Access token refreshed, releasing lock and setting tryRefresh to true after 15s");
                    if(resp?.data?.redirect) {
                        console.log("Malicious request, redirecting to login");
                        loginService.redirectToLogin();
                        controller.abort();
                    } else {
                        userService.getUserData().then(resp => {
                            // loginService.setUserLocal(resp);
                        }).catch(err => {
                            loginService.redirectToLogin();
                        });
                    }
                    setTimeout(() => { tryRefresh = true; errRefresh = false; }, 15000);
                    isRefreshing = false;
                    prevReq.sent = true;
                }).catch(err => {
                    // unable to refresh token, pass the original error to calling component/ logout the user(used here)
                    // console.log("Unable to refresh access token, rejecting request");
                    errRefresh = true;
                    isRefreshing = false;
                    loginService.redirectToLogin();
                });
                let retry_after = error?.response?.headers["retry-after"];
                if(retry_after) {
                    prevReq.sent = true;
                    return await asyncTimeout(retry_after).then(async () => {
                        console.debug("Retrying request after " + retry_after + "s ...");
                        return await axiosInstance(prevReq);
                    });
                } else {
                    return await axiosInstance(prevReq);
                }
            } else {
                // design choice to not submit refresh requests within 10s of previous refresh
                // console.log("Access token refreshed by earlier request, not attempting to refresh");
                prevReq.sent = true;
                return await axiosInstance(prevReq);
            }
        } else {
            return new Promise((resolve, reject) => {
                const refreshInterval = setInterval(() => {
                    if(!errRefresh && !isRefreshing) {
                        // console.log("Access token refreshed by previous request, attempting previous request again");
                        // console.log("Attempting follow request: " + prevReq?.url);
                        clearInterval(refreshInterval);
                        prevReq.sent = true;
                        resolve(axiosInstance(prevReq));
                    }
                    else if(errRefresh) {
                        // console.log("Error while refreshing, timed out, skipping follow request: " + prevReq?.url);
                        // console.log("Promise reject interval cleanup");
                        clearInterval(refreshInterval);
                        reject(Promise.reject(error));
                    }
                }, 2000);
            });
        }
    } else if(error?.response?.status === 403 && error?.response?.data?.redirect) {
        window.location.href = UI_HOST + error.response.data.redirect;
        controller.abort();
    } else if(error?.response?.status === 429 && !prevReq?.sent) {
        let retry_after = error.response.headers["retry-after"];
        if(retry_after) {
            prevReq.sent = true;
            return await asyncTimeout(retry_after).then(async () => {
                // console.debug("Retrying request after " + retry_after + "s ...");
                return await axiosInstance(prevReq);
            });
        }
    } else if(error?.response?.data?.redirect === '/login') {
        loginService.redirectToLogin();
        controller.abort();
    }
    return Promise.reject(error);
};

const asyncTimeout = (timeInSec) => {
    return new Promise(resolve => setTimeout(() => {
        // console.debug("Async timeout now resolved ...");
        resolve();
    }, timeInSec * 1000));
};
